import { render } from "./SpinnerControl.vue?vue&type=template&id=a5161dd8"
import script from "./SpinnerControl.vue?vue&type=script&lang=js"
export * from "./SpinnerControl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__